import { render, staticRenderFns } from "./MyPost.vue?vue&type=template&id=fe9952ae&scoped=true&"
import script from "./MyPost.vue?vue&type=script&lang=js&"
export * from "./MyPost.vue?vue&type=script&lang=js&"
import style0 from "./MyPost.vue?vue&type=style&index=0&id=fe9952ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe9952ae",
  null
  
)

export default component.exports